import { render } from "./ToSTerms.vue?vue&type=template&id=4fa0bfdc&scoped=true"
import script from "./ToSTerms.vue?vue&type=script&lang=js"
export * from "./ToSTerms.vue?vue&type=script&lang=js"

import "./ToSTerms.vue?vue&type=style&index=0&id=4fa0bfdc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa0bfdc"]])

export default __exports__